import { useAuth } from "@/features/auth"
import AgentDashboard from "@/app/components/dashboards/AgentDashboard"
import HRManagerDashboard from "@/app/components/dashboards/HRManagerDashboard"
import FMOCEODashboard from "@/app/components/dashboards/FMOCEODashboard"
import UserDashboard from "@/app/components/dashboards/UserDashboard"

export default function DashboardRouter() {
  const { user } = useAuth()

  if (!user) {
    return null
  }

  const handleError = (error: string) => {
    console.error("Dashboard error:", error)
    // You can implement a global error handler here
  }

  switch (user.role) {
    case "agent":
      return <AgentDashboard />
    case "hr_manager":
      return <HRManagerDashboard onError={handleError} />
    case "fmo_ceo":
      return <FMOCEODashboard />
    case "user":
      return <UserDashboard />
    default:
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-accent-900 mb-2">Unknown Role</h2>
            <p className="text-accent-600">Unable to determine dashboard for role: {user.role}</p>
          </div>
        </div>
      )
  }
}
